import { render, staticRenderFns } from "./labels.vue?vue&type=template&id=4cd9bde0&"
import script from "./labels.vue?vue&type=script&lang=ts&"
export * from "./labels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports